import actions from "./actions";

const {
  // Fetch all discounts
  FETCHING_DISCOUNT_BEGIN,
  FETCHING_DISCOUNT_SUCCESS,
  FETCHING_DISCOUNT_ERR,

  // Fetch single discount
  FETCHING_SINGLE_DISCOUNT_BEGIN,
  FETCHING_SINGLE_DISCOUNT_SUCCESS,
  FETCHING_SINGLE_DISCOUNT_ERR,

  // Add discount
  ADDING_DISCOUNT_BEGIN,
  ADDING_DISCOUNT_SUCCESS,
  ADDING_DISCOUNT_ERR,

  // Update discount
  UPDATE_DISCOUNT_BEGIN,
  UPDATE_DISCOUNT_SUCCESS,
  UPDATE_DISCOUNT_ERR,

  // Delete discount
  DELETE_DISCOUNT_BEGIN,
  DELETE_DISCOUNT_SUCCESS,
  DELETE_DISCOUNT_ERR,

  // Get usage statistics
  FETCHING_DISCOUNT_STATS_BEGIN,
  FETCHING_DISCOUNT_STATS_SUCCESS,
  FETCHING_DISCOUNT_STATS_ERR,

  // Validate coupon
  VALIDATE_COUPON_BEGIN,
  VALIDATE_COUPON_SUCCESS,
  VALIDATE_COUPON_ERR,

  // Apply coupon
  APPLY_COUPON_BEGIN,
  APPLY_COUPON_SUCCESS,
  APPLY_COUPON_ERR,
} = actions;

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const singleDiscountInitialState = {
  data: null,
  loading: false,
  error: null,
};

const statsInitialState = {
  data: null,
  loading: false,
  error: null,
};

const couponInitialState = {
  data: null,
  loading: false,
  error: null,
};

// Main discount reducer (for list operations)
const DiscountReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCHING_DISCOUNT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case FETCHING_DISCOUNT_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case FETCHING_DISCOUNT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case ADDING_DISCOUNT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADDING_DISCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ADDING_DISCOUNT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case UPDATE_DISCOUNT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_DISCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_DISCOUNT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case DELETE_DISCOUNT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_DISCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_DISCOUNT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

// Single discount reducer
const SingleDiscountReducer = (state = singleDiscountInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCHING_SINGLE_DISCOUNT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case FETCHING_SINGLE_DISCOUNT_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case FETCHING_SINGLE_DISCOUNT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

// Discount statistics reducer
const DiscountStatsReducer = (state = statsInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCHING_DISCOUNT_STATS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case FETCHING_DISCOUNT_STATS_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case FETCHING_DISCOUNT_STATS_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

// Coupon validation/application reducer
const CouponReducer = (state = couponInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case VALIDATE_COUPON_BEGIN:
    case APPLY_COUPON_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case VALIDATE_COUPON_SUCCESS:
    case APPLY_COUPON_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case VALIDATE_COUPON_ERR:
    case APPLY_COUPON_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export {
  DiscountReducer,
  SingleDiscountReducer,
  DiscountStatsReducer,
  CouponReducer,
};
